export type DashboardView =
  | 'reservations'
  | 'users'
  | 'profile'
  | 'messages'
  | 'tables';

export type UserRole = 'admin' | 'manager' | 'user';

export interface PaginationResult<T> {
  items: T[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export enum ReservationStatus {
  BOOKED = 'booked',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  PAID = 'paid',
  COMPLETED = 'completed',
}

export interface Reservation {
  id: string;
  customerName: string;
  customerEmail: string;
  customerPhone?: string;
  date: string;
  timeStart: string;
  timeEnd?: string;
  table: any;
  isVip: boolean;
  numberOfGuests: number;
  notes?: string;
  status: ReservationStatus;
  paidAmount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface ReservationSummary {
  trendLast7Days: {
    date: string;
    totalCount: number;
    cancelledCount: number;
  }[];
  thisWeekCount: number;
  todayCount: number;
  nextHourCount: number;
  cancelRate: number;
  availableRegularTables?: number;
  availableVipTables?: number;
  totalRegularTables?: number;
  totalVipTables?: number;
  paidReservations?: number;
}

export interface ContactMessage {
  id: string;
  name: string;
  email: string;
  phone: string;
  message: string;
  createdAt: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  isActive: boolean;
  isDeleted: boolean;
  lastLogin?: string;
  lastLoginIp?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserPayload {
  name: string;
  email: string;
  password: string;
  role: UserRole;
}

export interface LoginResponse {
  accessToken: string;
}

export interface ResetPasswordPayload {
  email: string;
  newPassword: string;
}

export interface UpdateMyPasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export interface AuthPayload {
  role?: UserRole;
  email?: string;
}
export interface Table {
  id: string;
  tableNumber: string;
  shape: 'round' | 'rectangular';
  capacity: number;
  isVip: boolean;
  reserved: boolean;
  position?: { x: number; y: number };
  tableImage?: any
};
export interface TablesTabProps {
  tables: Table[];
  onAddTable: (form: any) => void;
  onEditTable: (id: string) => void;
  onDeleteTable: (id: string) => void;
}
